var map = {
	"./base-init.conf.ts": 48074,
	"./baseConfiguration.ts": 42959,
	"./baseSelectorConfiguration.ts": 83612,
	"legacy/customer/base/orpea/base-init.conf.ts": 48074,
	"legacy/customer/base/orpea/baseConfiguration.ts": 42959,
	"legacy/customer/base/orpea/baseSelectorConfiguration.ts": 83612
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75571;